import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@gemini/core';
import { LoaderIcon } from '@gemini/icons';
import { useShellTranslation } from '@/hooks/useShellTranslation/useShellTranslation';
export const PageSpinner = ({ flexDirection = 'column' }) => {
    const { t } = useShellTranslation();
    return (_jsxs(Box, { position: "absolute", top: "0", bottom: "0", left: "0", right: "0", testId: "page-spinner", display: "flex", flexDirection: flexDirection, alignItems: "center", justifyContent: "center", backgroundColor: "color.background.default", children: [_jsx("div", { style: {
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '50px',
                    height: '50px',
                    animation: 'spin 1s linear infinite',
                }, children: _jsx(LoaderIcon, { size: "sizing.24" }) }), _jsxs(Box, { typography: "typography.body.16.bold", children: [t('search.dropdown.loader_alt'), "..."] }), _jsx("style", { children: `
                    @keyframes spin {
                        0% { transform: rotate(0deg); }
                        100% { transform: rotate(360deg); }
                    }
                ` })] }));
};
